const map = L.map("map", {
    attributionControl: false,
    fullscreenControl: true
}).setView([35.6892, 51.389], 13);

L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: "",
}).addTo(map).on('load', function() {
    document.querySelector('.leaflet-control-fullscreen-button')
           .setAttribute('title', `${langText["text_circle_map_view"]}`);
});



let originMarker = null;
let destinationMarker = null;
let routeLine = null;
let tempRouteLine = null;
let straightLine = null;
let originPoint = null;
let destinationPoint = null;
let originName = "Origin not selected";
let destinationName = "Destination not selected";
let isLoading = false;
let routeRequest = null;
let currentSearchRequest = null;

const elements = {
    originInput: document.getElementById("origin-input"),
    destinationInput: document.getElementById("destination-input"),
    originSuggestions: document.getElementById("origin-suggestions"),
    destinationSuggestions: document.getElementById("destination-suggestions"),
    drawRouteBtn: document.getElementById("draw-route"),
    routeContainer: document.getElementById("route-container"),
    originNameElement: document.getElementById("origin-name"),
    destinationNameElement: document.getElementById("destination-name"),
    distanceKmElement: document.getElementById("distance-km"),
    distanceMilesElement: document.getElementById("distance-miles"),
    durationElement: document.getElementById("duration"),
    instructionsList: document.getElementById("instructions-list"),
    clearOriginBtn: document.getElementById("clear-origin"),
    clearDestinationBtn: document.getElementById("clear-destination"),
    clearAllBtn: document.getElementById("clear-all-btn"),
    swapBtn: document.getElementById("swap-btn"),

    originCoordsLat: document.getElementById("origin-coords-lat"),
    originCoordsLng: document.getElementById("origin-coords-lng"),
    destinationCoordsLat: document.getElementById("destination-coords-lat"),
    destinationCoordsLng: document.getElementById("destination-coords-lng"),

    loadingOverlay: document.getElementById("loading-overlay"),
    loadingMessage: document.getElementById("loading-message"),
    originSearchLoading: document.getElementById("origin-search-loading"),
    destinationSearchLoading: document.getElementById(
        "destination-search-loading"
    ),
    originCoordsInput: document.getElementById("origin-coords"),
    destinationCoordsInput: document.getElementById("destination-coords"),
    optimalDistanceElement: document.getElementById("optimal-distance"),
    straightDistanceElement: document.getElementById("straight-distance"),
    optimalDurationElement: document.getElementById("optimal-duration"),
};

function isValidCoordinates(lat, lng) {
    const latNum = parseFloat(lat);
    const lngNum = parseFloat(lng);
    return !isNaN(latNum) && !isNaN(lngNum) &&
           latNum >= -90 && latNum <= 90 &&
           lngNum >= -180 && lngNum <= 180;
}

async function setAddressFromCoords(lat, lng, type) {
    const point = L.latLng(parseFloat(lat), parseFloat(lng));

    if (type === "origin") {
        originPoint = point;
        await fetchLocationName(point, "origin");
    } else {
        destinationPoint = point;
        await fetchLocationName(point, "destination");
    }

    return point;
}
function showCustomAlert(message) {
    const alertDiv = document.createElement("div");
    alertDiv.className = "custom-alert";
    alertDiv.innerHTML = `
        ${message}
        <i class="fas fa-times"></i>
    `;

    document.body.appendChild(alertDiv);

    alertDiv.querySelector("i").addEventListener("click", function () {
        alertDiv.remove();
    });

    setTimeout(() => {
        if (alertDiv.parentNode) {
            alertDiv.remove();
        }
    }, 3000);
}

function showLoading(message) {
    elements.loadingMessage.textContent = message;
    elements.loadingOverlay.classList.remove("hidden");
}

function hideLoading() {
    elements.loadingOverlay.classList.add("hidden");
}

function showSearchLoading(inputType) {
    if (inputType === "origin") {
        elements.originSearchLoading.classList.remove("hidden");
    } else {
        elements.destinationSearchLoading.classList.remove("hidden");
    }
}

function hideSearchLoading(inputType) {
    if (inputType === "origin") {
        elements.originSearchLoading.classList.add("hidden");
    } else {
        elements.destinationSearchLoading.classList.add("hidden");
    }
}

function debounce(func, wait, immediate) {
    let timeout;
    return function () {
        const context = this;
        const args = arguments;
        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function searchLocation(query, suggestionsContainer, type) {
    if (query.length < 3) {
        suggestionsContainer.style.display = "none";
        hideSearchLoading(type);
        return;
    }

    if (currentSearchRequest) {
        currentSearchRequest.cancel(langText["distance_tool_new_request"]);
    }

    const CancelToken = axios.CancelToken;
    currentSearchRequest = CancelToken.source();

    showSearchLoading(type);

    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
        query
    )}&addressdetails=1&limit=5&accept-language=en`;

    axios
        .get(url, {
            cancelToken: currentSearchRequest.token,
        })
        .then((response) => {
            const results = response.data;
            suggestionsContainer.innerHTML = "";

            if (results.length === 0) {
                const item = document.createElement("div");
                item.className = "suggestion-item text-gray-500";
                item.textContent = langText["distance_tool_no_results"];
                suggestionsContainer.appendChild(item);
            } else {
                results.forEach((result) => {
                    const item = document.createElement("div");
                    item.className = "suggestion-item";

                    let displayName = result.display_name;
                    if (displayName.length > 60) {
                        displayName = displayName.substring(0, 60) + "...";
                    }

                    item.textContent = displayName;
                    item.addEventListener("click", function () {
                        const inputElement =
                            type === "origin"
                                ? elements.originInput
                                : elements.destinationInput;
                        inputElement.value = displayName;
                        suggestionsContainer.style.display = "none";

                        const point = L.latLng(
                            parseFloat(result.lat),
                            parseFloat(result.lon)
                        );

                        if (type === "origin") {
                            originPoint = point;
                            originName = displayName;
                            placeOriginMarker(point);
                        } else {
                            destinationPoint = point;
                            destinationName = displayName;
                            placeDestinationMarker(point);
                        }

                        updateRouteInfo();

                        if (originPoint && destinationPoint) {
                            drawRoute();
                        }

                        map.setView(point, 15);

                    });

                    suggestionsContainer.appendChild(item);
                });
            }

            suggestionsContainer.style.display = "block";
            hideSearchLoading(type);
        })
        .catch((error) => {
            if (!axios.isCancel(error)) {
                console.error("Error fetching suggestions:", error);
            }
            hideSearchLoading(type);
        });
}

function placeOriginMarker(point) {
    if (originMarker) map.removeLayer(originMarker);

    originMarker = L.marker(point, {
        icon: L.divIcon({
            className: "origin-marker",
            html: `
                <div class="relative">
                    <div class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></div>
                    <div class="relative inline-flex rounded-full h-8 w-8 bg-blue-500 border-3 border-blue-200 items-center justify-center">
                       <svg class="w-4 h-4 text-white" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"/>
        </svg>
                    </div>
                </div>
            `,
            iconSize: [32, 32],
            iconAnchor: [16, 16],
        }),
    }).addTo(map);

    originMarker
        .bindPopup(
            `<div class="font-bold text-blue-600">${langText["text_distance_calculator_origin"]}</div>
        `
        )
        .openPopup();
}

function placeDestinationMarker(point) {
    if (destinationMarker) map.removeLayer(destinationMarker);

    destinationMarker = L.marker(point, {
        icon: L.divIcon({
            className: "destination-marker pulse-animation",
            html: `
                <div class="relative">
                    <div class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></div>
                    <div class="relative inline-flex rounded-full h-8 w-8 bg-red-500 border-3 border-red-200 items-center justify-center">
                       <svg class="w-4 h-4 text-white" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"/>
                        </svg>
                    </div>
                </div>
            `,
            iconSize: [32, 32],
            iconAnchor: [16, 16],
        }),
    }).addTo(map);

    setTimeout(() => {
        if (destinationMarker && destinationMarker._icon) {
            destinationMarker._icon.classList.remove("pulse-animation");
        }
    }, 3000);

    destinationMarker
        .bindPopup(
            `<div class="font-bold text-red-600">${langText["text_distance_calculator_destination"]}</div>
        `
        )
        .openPopup();
}

function drawTempRoute() {
    if (tempRouteLine) map.removeLayer(tempRouteLine);

    if (originPoint && destinationPoint) {
        tempRouteLine = L.polyline([originPoint, destinationPoint], {
            color: "#3b82f6",
            weight: 5,
            opacity: 0.8,
            dashArray: "10, 10",
            className: "temp-route",
            lineJoin: "round",
        }).addTo(map);
    }
}

function cancelRouteRequest() {
    if (routeRequest) {
        routeRequest.cancel(langText["distance_tool_cancel_routing"]);
        routeRequest = null;
    }
}

function clearRoute(keepPoints = false) {
    cancelRouteRequest();

    if (originMarker && !keepPoints) map.removeLayer(originMarker);
    if (destinationMarker && !keepPoints) map.removeLayer(destinationMarker);
    if (routeLine) map.removeLayer(routeLine);
    if (tempRouteLine) map.removeLayer(tempRouteLine);
    if (straightLine) map.removeLayer(straightLine);

    if (!keepPoints) {
        originPoint = null;
        destinationPoint = null;
        originName = langText["distance_tool_no_origin_selected"];
        destinationName = langText["distance_tool_no_destination_selected"];
        elements.originInput.value = "";
        elements.destinationInput.value = "";
        elements.originCoordsInput.value = "";
        elements.destinationCoordsInput.value = "";

        map.off("click");
        map.on("click", handleMapClick);
    }

    routeLine = null;
    tempRouteLine = null;
    straightLine = null;

    if (!keepPoints) {
        hideRouteContainer();
    }
    elements.instructionsList.innerHTML = "";

    updateRouteInfo();

    isLoading = false;
    const originalText = '<i class="fas fa-route mr-2"></i> Draw route';
    elements.drawRouteBtn.innerHTML = originalText;
    elements.drawRouteBtn.disabled = false;

    hideLoading();
}

function clearOrigin() {
    if (originMarker) map.removeLayer(originMarker);
    originPoint = null;
    originName = langText["distance_tool_no_origin_selected"];
    elements.originInput.value = "";
    elements.originSuggestions.style.display = "none";
    updateRouteInfo();

    map.off("click");
    map.on("click", handleMapClick);

    if (!destinationPoint) {
        hideRouteContainer();
    }
}

function clearDestination() {
    if (destinationMarker) map.removeLayer(destinationMarker);
    destinationPoint = null;
    destinationName = langText["distance_tool_no_destination_selected"];
    elements.destinationInput.value = "";
    elements.destinationSuggestions.style.display = "none";
    updateRouteInfo();

    map.off("click");
    map.on("click", handleMapClick);

    if (!originPoint) {
        hideRouteContainer();
    }
}

function showRouteContainer() {
    elements.routeContainer.classList.remove("hidden");
    elements.routeContainer.scrollIntoView({
        behavior: "smooth",
    });
}

function hideRouteContainer() {
    elements.routeContainer.classList.add("hidden");
}

function updateRouteInfo() {
    // elements.originNameElement.textContent = "Origin";
    // elements.destinationNameElement.textContent = "Distination";

    if (originPoint && destinationPoint) {
        const distanceKm = originPoint.distanceTo(destinationPoint) / 1000;
        const distanceMiles = (distanceKm * 0.621371).toFixed(1);
        const durationMinutes = Math.round(distanceKm * 1.5);

        elements.distanceKmElement.textContent = distanceKm.toFixed(1);
        elements.distanceMilesElement.textContent = distanceMiles;
        elements.durationElement.textContent = durationMinutes;
    } else {
        elements.distanceKmElement.textContent = "0";
        elements.distanceMilesElement.textContent = "0";
        elements.durationElement.textContent = "0";
    }
}

async function fetchLocationName(point, type) {
    try {
        const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${point.lat}&lon=${point.lng}&accept-language=en`;
        const response = await axios.get(url);

        const address = response.data.address;
        let displayName = "";

        if (address.road) displayName += address.road + "، ";
        if (address.neighbourhood) displayName += address.neighbourhood + "، ";
        if (address.suburb) displayName += address.suburb + "، ";
        if (address.city) displayName += address.city + "، ";
        if (address.state) displayName += address.state;

        if (displayName.endsWith("، ")) {
            displayName = displayName.slice(0, -2);
        }

        if (displayName) {
            if (type === "origin") {
                elements.originInput.value = displayName;
                originName = displayName;
                placeOriginMarker(point);
            } else {
                elements.destinationInput.value = displayName;
                destinationName = displayName;
                placeDestinationMarker(point);
            }
        } else {
            const fallbackName = `${point.lat.toFixed(4)}, ${point.lng.toFixed(
                4
            )}`;
            if (type === "origin") {
                elements.originInput.value = fallbackName;
                originName = fallbackName;
                placeOriginMarker(point);
            } else {
                elements.destinationInput.value = fallbackName;
                destinationName = fallbackName;
                placeDestinationMarker(point);
            }
        }

        updateRouteInfo();
    } catch (error) {
        console.error("Error fetching location name:", error);
        const fallbackName = `${point.lat.toFixed(4)}, ${point.lng.toFixed(4)}`;
        if (type === "origin") {
            elements.originInput.value = fallbackName;
            originName = fallbackName;
            placeOriginMarker(point);
        } else {
            elements.destinationInput.value = fallbackName;
            destinationName = fallbackName;
            placeDestinationMarker(point);
        }
        updateRouteInfo();
    } finally {
        hideLoading();
    }
}

async function drawRoute() {
    if (
        (!elements.originInput.value &&
         (elements.originCoordsLat.value || elements.originCoordsLng.value)) ||
        (!elements.destinationInput.value &&
         (elements.destinationCoordsLat.value || elements.destinationCoordsLng.value))
    ) {
        try {
            showLoading(langText["distance_tool_processing"]);

            if (!elements.originInput.value &&
                (elements.originCoordsLat.value || elements.originCoordsLng.value)) {

                if (!elements.originCoordsLat.value || !elements.originCoordsLng.value) {
                    throw new Error('Please enter both latitude and longitude for origin');
                }

                if (!isValidCoordinates(elements.originCoordsLat.value, elements.originCoordsLng.value)) {
                    throw new Error('Invalid origin coordinates. Please enter valid latitude and longitude.');
                }

                await setAddressFromCoords(
                    elements.originCoordsLat.value,
                    elements.originCoordsLng.value,
                    "origin"
                );
            }

            if (!elements.destinationInput.value &&
                (elements.destinationCoordsLat.value || elements.destinationCoordsLng.value)) {

                if (!elements.destinationCoordsLat.value || !elements.destinationCoordsLng.value) {
                    throw new Error('Please enter both latitude and longitude for destination');
                }

                if (!isValidCoordinates(elements.destinationCoordsLat.value, elements.destinationCoordsLng.value)) {
                    throw new Error('Invalid destination coordinates. Please enter valid latitude and longitude.');
                }

                await setAddressFromCoords(
                    elements.destinationCoordsLat.value,
                    elements.destinationCoordsLng.value,
                    "destination"
                );
            }
        } catch (error) {
            hideLoading();
            showCustomAlert(error.message);
            return;
        } finally {
            hideLoading();
        }
    }

    if (!originPoint || !destinationPoint) {
        showCustomAlert(langText["distance_tool_either"]);
        return;
    }

    if (isLoading) {
        cancelRouteRequest();
        clearRoute(true);
    }

    isLoading = true;
    const originalText = elements.drawRouteBtn.innerHTML;
    elements.drawRouteBtn.innerHTML = `<span>${langText["distance_tool_drawing_route"]}</span><div class="loading-spinner"></div>`;
    elements.drawRouteBtn.disabled = true;

    showLoading(langText["distance_tool_calculating"]);

    if (routeLine) map.removeLayer(routeLine);
    if (straightLine) map.removeLayer(straightLine);
    if (tempRouteLine) map.removeLayer(tempRouteLine);

    straightLine = L.polyline([originPoint, destinationPoint], {
        color: "#ef4444",
        weight: 3,
        dashArray: "5, 5",
        opacity: 0.7,
        className: "straight-route-line",
    }).addTo(map);

    const straightDistance = originPoint.distanceTo(destinationPoint) / 1000;
    const straightDistanceMiles = (straightDistance * 0.621371).toFixed(1);

    showRouteContainer();
    elements.instructionsList.innerHTML = "";

    const osrmUrl = `https://router.project-osrm.org/route/v1/driving/${originPoint.lng},${originPoint.lat};${destinationPoint.lng},${destinationPoint.lat}?overview=full&geometries=geojson&steps=true&alternatives=false`;

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    routeRequest = source;

    try {
        const response = await axios.get(osrmUrl, {
            cancelToken: source.token,
        });

        const route = response.data.routes[0];
        const distanceKm = (route.distance / 1000).toFixed(1);
        const durationMinutes = Math.round(route.duration / 60);

        const routeCoordinates = route.geometry.coordinates.map((coord) => [
            coord[1],
            coord[0],
        ]);

        routeLine = L.polyline(routeCoordinates, {
            color: "#3b82f6",
            weight: 5,
            opacity: 0.8,
            lineJoin: "round",
            className: "optimal-route-line",
        }).addTo(map);

        updateRouteComparison(distanceKm, straightDistance, durationMinutes);

        const bounds = L.latLngBounds([
            ...routeCoordinates,
            originPoint,
            destinationPoint,
        ]);
        map.fitBounds(bounds, {
            padding: [50, 50],
        });

        displayRouteInstructions(route.legs[0].steps);

        if (!elements.originCoordsLat.value || !elements.originCoordsLng.value) {
            elements.originCoordsLat.value = originPoint.lat.toFixed(6);
            elements.originCoordsLng.value = originPoint.lng.toFixed(6);
        }

        if (!elements.destinationCoordsLat.value || !elements.destinationCoordsLng.value) {
            elements.destinationCoordsLat.value = destinationPoint.lat.toFixed(6);
            elements.destinationCoordsLng.value = destinationPoint.lng.toFixed(6);
        }
    } catch (error) {
        if (axios.isCancel(error)) {
            console.log("Route request canceled:", error.message);
            return;
        }

        console.error("Error fetching route:", error);

        updateRouteComparison(
            straightDistance.toFixed(1),
            straightDistance,
            Math.round(straightDistance * 1.5)
        );

        showCustomAlert(langText["distance_tool_route_error"]);
    } finally {
        isLoading = false;
        routeRequest = null;
        elements.drawRouteBtn.innerHTML = originalText;
        elements.drawRouteBtn.disabled = false;
        hideLoading();

        elements.originSuggestions.style.display = "none";
        elements.destinationSuggestions.style.display = "none";
    }
}

function updateRouteComparison(optimalDistance, straightDistance, duration) {
    const optimalDistanceEl = document.getElementById("optimal-distance");
    const straightDistanceEl = document.getElementById("straight-distance");
    const optimalDurationEl = document.getElementById("optimal-duration");

    if (optimalDistanceEl)
        optimalDistanceEl.textContent = `${optimalDistance} km (${(
            optimalDistance * 0.621371
        ).toFixed(1)} mi)`;

    if (straightDistanceEl)
        straightDistanceEl.textContent = `${straightDistance.toFixed(1)} km (${(
            straightDistance * 0.621371
        ).toFixed(1)} mi)`;
    // if (optimalDurationEl) optimalDurationEl.textContent = `${duration} min`;

    if (elements.distanceKmElement)
        elements.distanceKmElement.textContent = optimalDistance;
    if (elements.distanceMilesElement) {
        elements.distanceMilesElement.textContent = (
            straightDistance * 0.621371
        ).toFixed(1);
    }
    if (elements.durationElement)
        elements.durationElement.textContent = duration;
}

function displayRouteInstructions(steps) {
    elements.instructionsList.innerHTML = "";

    const header = document.createElement("div");
    header.className = "instructions-header";
    header.innerHTML = `
        <div style="color: black;" class="font-medium">${langText["text_distance_calculator_route_guide"]}</div>
        <svg class="w-4 h-4 transition-transform duration-200" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `;

    const content = document.createElement("div");
    content.className = "instructions-content expanded";

    let isExpanded = true;

    header.addEventListener("click", function () {
        isExpanded = !isExpanded;
        if (isExpanded) {
            content.classList.remove("collapsed");
            content.classList.add("expanded");
            header.querySelector("i").classList.remove("fa-chevron-up");
            header.querySelector("i").classList.add("fa-chevron-down");
        } else {
            content.classList.remove("expanded");
            content.classList.add("collapsed");
            header.querySelector("i").classList.remove("fa-chevron-down");
            header.querySelector("i").classList.add("fa-chevron-up");
        }
    });

    if (steps.length > 0) {
        const destinationItem = document.createElement("div");
        destinationItem.className =
            "flex items-start py-3 px-4 hover:bg-gray-50 hover:bg-opacity-10 transition-colors";

        const destinationIcon = document.createElement("div");
        destinationIcon.className =
            "flex items-center justify-center w-6 h-6 rounded-full bg-red-500 text-white ml-3 mr-3 mt-1 flex-shrink-0";
        destinationIcon.innerHTML = `
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
            </svg>
        `;

        const destinationContent = document.createElement("div");
        destinationContent.className = "flex-1";

        const destinationText = document.createElement("div");
        destinationText.className = "text-black font-bold";
        destinationText.textContent =
            document.querySelector("#origin-input").value;

        destinationContent.appendChild(destinationText);
        destinationItem.appendChild(destinationIcon);
        destinationItem.appendChild(destinationContent);

        content.appendChild(destinationItem);
    }

    steps.forEach((step, index) => {
        if (
            step.maneuver &&
            (step.maneuver.type !== "turn" ||
                (step.maneuver.modifier !== "straight" &&
                    step.maneuver.modifier !== "slight right" &&
                    step.maneuver.modifier !== "slight left"))
        ) {
            const instructionItem = document.createElement("div");
            instructionItem.className =
                "flex items-start py-3 px-4 hover:bg-gray-50 transition-colors";

            const instructionNumber = document.createElement("div");
            instructionNumber.className =
                "flex items-center justify-center w-6 h-6 rounded-full bg-blue-500 text-white text-sm font-medium ml-3 mr-3 mt-1 flex-shrink-0";
            instructionNumber.textContent = index + 1;

            const instructionContent = document.createElement("div");
            instructionContent.className = "flex-1";

            const instructionMainText = document.createElement("div");
            instructionMainText.className = "text-gray-800 font-medium";
            instructionMainText.textContent =
                step.name || step.maneuver.instruction || "Continue route";

            const instructionDistance = document.createElement("div");
            instructionDistance.className = "text-gray-500 text-sm mt-1";
            instructionDistance.textContent = `${(step.distance / 1000).toFixed(
                1
            )} km`;

            instructionContent.appendChild(instructionMainText);
            instructionContent.appendChild(instructionDistance);

            instructionItem.appendChild(instructionNumber);
            instructionItem.appendChild(instructionContent);

            content.appendChild(instructionItem);
        }
    });

    const destinationValue = document.querySelector("#destination-input").value;
    console.log(destinationValue);

    const destinationItem = document.createElement("div");
    destinationItem.className =
        "flex items-start py-3 px-4 hover:bg-white hover:bg-opacity-5 transition-colors";

    const destinationIcon = document.createElement("div");
    destinationIcon.className =
        "flex items-center justify-center w-6 h-6 rounded-full bg-green-500 text-white ml-3 mr-3 mt-1 flex-shrink-0";
    destinationIcon.innerHTML = `
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
            </svg>
        `;

    const destinationContent = document.createElement("div");
    destinationContent.className = "flex-1";

    const destinationText = document.createElement("div");
    destinationText.className = "text-black font-medium";
    destinationText.textContent = destinationValue;

    destinationContent.appendChild(destinationText);
    destinationItem.appendChild(destinationIcon);
    destinationItem.appendChild(destinationContent);

    content.appendChild(destinationItem);
    console.log(destinationItem);

    elements.instructionsList.appendChild(header);
    elements.instructionsList.appendChild(content);
}

function handleMapClick(e) {
    if (originPoint && destinationPoint) {
        showCustomAlert(langText["distance_tool_click_clear_btn"]);
        return;
    }

    if (isLoading) {
        if (confirm(langText["distance_tool_cancel_current_route"])) {
            clearRoute(true);
        } else {
            return;
        }
    }

    const point = e.latlng;
    const coords = `${point.lat.toFixed(6)},${point.lng.toFixed(6)}`;

    if (!originPoint) {
        originPoint = point;
        elements.originCoordsLat.value = point.lat.toFixed(6);
        elements.originCoordsLng.value = point.lng.toFixed(6);
        showLoading(langText["distance_tool_fetch_origin"]);
        fetchLocationName(originPoint, "origin");
        placeOriginMarker(originPoint);
        updateRouteInfo();
    } else if (!destinationPoint) {
        destinationPoint = point;
        elements.destinationCoordsLat.value = point.lat.toFixed(6);
        elements.destinationCoordsLng.value = point.lng.toFixed(6);
        showLoading(langText["distance_tool_fetch_destination"]);
        fetchLocationName(destinationPoint, "destination");
        placeDestinationMarker(destinationPoint);
        updateRouteInfo();
        drawRoute();
    }
}

function clearOriginCoords() {
    elements.originCoordsLat.value = "";
    elements.originCoordsLng.value = "";
    if (!originPoint) return;

    originPoint = null;
    originName = langText["distance_tool_no_origin_selected"];
    elements.originInput.value = "";
    if (originMarker) map.removeLayer(originMarker);
    updateRouteInfo();
}


function clearDestinationCoords() {
    elements.destinationCoordsLat.value = "";
    elements.destinationCoordsLng.value = "";
    if (!destinationPoint) return;

    destinationPoint = null;
    destinationName = langText["distance_tool_no_destination_selected"];
    elements.destinationInput.value = "";
    if (destinationMarker) map.removeLayer(destinationMarker);
    updateRouteInfo();
}

function setupEventListeners() {
    map.on("click", handleMapClick);

    elements.originInput.addEventListener("focus", function () {
        if (this.value.length >= 3) {
            searchLocation(this.value, elements.originSuggestions, "origin");
        }
    });

    elements.destinationInput.addEventListener("focus", function () {
        if (this.value.length >= 3) {
            searchLocation(
                this.value,
                elements.destinationSuggestions,
                "destination"
            );
        }
    });

    elements.originInput.addEventListener(
        "input",
        debounce(function () {
            searchLocation(this.value, elements.originSuggestions, "origin");
        }, 300)
    );

    elements.destinationInput.addEventListener(
        "input",
        debounce(function () {
            searchLocation(
                this.value,
                elements.destinationSuggestions,
                "destination"
            );
        }, 300)
    );

    document.addEventListener("click", function (e) {
        if (
            !elements.originInput.contains(e.target) &&
            !elements.originSuggestions.contains(e.target)
        ) {
            elements.originSuggestions.style.display = "none";
        }

        if (
            !elements.destinationInput.contains(e.target) &&
            !elements.destinationSuggestions.contains(e.target)
        ) {
            elements.destinationSuggestions.style.display = "none";
        }
    });

    elements.drawRouteBtn.addEventListener("click", function () {
        if (originPoint && destinationPoint) {
            drawRoute();
        } else {
            showCustomAlert(langText["distance_tool_either"]);
        }
    });

    elements.clearOriginBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        if (isLoading) {
            if (confirm(langText["distance_tool_cancel_current_route"])) {
                clearOrigin();
            }
        } else {
            clearOrigin();
        }
    });

    elements.clearDestinationBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        if (isLoading) {
            if (confirm(langText["cancel_distance"])) {
                clearDestination();
            }
        } else {
            clearDestination();
        }
    });


    elements.originCoordsLat.addEventListener("change", function() {
        if (this.value && elements.originCoordsLng.value &&
            isValidCoordinates(this.value, elements.originCoordsLng.value)) {
            setAddressFromCoords(this.value, elements.originCoordsLng.value, "origin");
        }
    });

    elements.originCoordsLng.addEventListener("change", function() {
        if (this.value && elements.originCoordsLat.value &&
            isValidCoordinates(elements.originCoordsLat.value, this.value)) {
            setAddressFromCoords(elements.originCoordsLat.value, this.value, "origin");
        }
    });

    // elements.destinationCoordsInput.addEventListener("change", function () {
    //     if (this.value && isValidCoordinates(this.value)) {
    //         setAddressFromCoords(this.value, "destination");
    //     }
    // });

    elements.destinationCoordsLat.addEventListener("change", function() {
        if (this.value && elements.destinationCoordsLng.value &&
            isValidCoordinates(this.value, elements.destinationCoordsLng.value)) {
            setAddressFromCoords(this.value, elements.destinationCoordsLng.value, "destination");
        }
    });

    elements.destinationCoordsLng.addEventListener("change", function() {
        if (this.value && elements.destinationCoordsLat.value &&
            isValidCoordinates(elements.destinationCoordsLat.value, this.value)) {
            setAddressFromCoords(elements.destinationCoordsLat.value, this.value, "destination");
        }
    });

    elements.clearAllBtn.addEventListener("click", function () {
        if (isLoading) {
            if (confirm(langText["cancel_all"])) {
                clearRoute();
            }
        } else {
            clearRoute();
        }
    });

    elements.swapBtn.addEventListener("click", function () {
        if (originPoint && destinationPoint) {
            const tempPoint = originPoint;
            const tempName = originName;

            originPoint = destinationPoint;
            originName = destinationName;

            destinationPoint = tempPoint;
            destinationName = tempName;

            const tempInput = elements.originInput.value;
            elements.originInput.value = elements.destinationInput.value;
            elements.destinationInput.value = tempInput;

            placeOriginMarker(originPoint);
            placeDestinationMarker(destinationPoint);

            drawRoute();
        } else if (originPoint && !destinationPoint) {
            destinationPoint = originPoint;
            destinationName = originName;
            elements.destinationInput.value = elements.originInput.value;

            originPoint = null;
            originName = langText["distance_tool_no_origin_selected"];

            elements.originInput.value = "";

            if (originMarker) map.removeLayer(originMarker);
            placeDestinationMarker(destinationPoint);
            updateRouteInfo();
        } else if (!originPoint && destinationPoint) {
            originPoint = destinationPoint;
            originName = destinationName;
            elements.originInput.value = elements.destinationInput.value;

            destinationPoint = null;
            destinationName = langText["distance_tool_no_destination_selected"];

            elements.destinationInput.value = "";

            if (destinationMarker) map.removeLayer(destinationMarker);
            placeOriginMarker(originPoint);
            updateRouteInfo();
        }
    });

    elements.drawRouteBtn.addEventListener("mouseenter", function () {
        // this.querySelector("i").classList.add("fa-beat");
    });

    elements.drawRouteBtn.addEventListener("mouseleave", function () {
        // this.querySelector("i").classList.remove("fa-beat");
    });

    const container = document.querySelector(".route-path-container");
    container.className = "route-path-container";
    container.classList.add("show-both");
}

document.addEventListener("DOMContentLoaded", function () {
    setupEventListeners();

    document.querySelector(".language").addEventListener("click", function () {

        document.querySelector(".lang").classList.toggle("active");
})
});
